var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{key:_vm.studyId},[_c('ContextHeader',[(_vm.study)?_c('Studyheader',{attrs:{"study":_vm.study}}):_vm._e()],1),_c('StudyNavigation',{attrs:{"study-id":_vm.studyId,"study":_vm.study}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }